import React from 'react';

import { string, node } from 'prop-types';

export default function Box({ children, className = '', ...props }) {
  return (
    <div
      className={`flex flex-shrink-1 justify-content-between align-items-center mb-2 ${className}`}
      data-testid="box-component"
      {...props}
    >
      {children}
    </div>
  );
}

Box.propTypes = {
  children: node.isRequired,
  className: string
};

Box.defaultProps = {
  className: ''
};
